import { render, staticRenderFns } from "./ArticleView.vue?vue&type=template&id=d7c01cb2&scoped=true"
import script from "./ArticleView.vue?vue&type=script&lang=js"
export * from "./ArticleView.vue?vue&type=script&lang=js"
import style0 from "./ArticleView.vue?vue&type=style&index=0&id=d7c01cb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c01cb2",
  null
  
)

export default component.exports